import * as React from 'react';
import Banner from '../Banner';

type Props = {
  errors: object;
  noIcon?: boolean;
};

const FormErrors = (props: Props) => {
  const errors = Object.entries(props.errors).reduce((acc, curr) => {
    const [, value] = curr;

    if (typeof value === 'object') {
      return [...acc, ...Object.entries(value).map(x => x[1])];
    }

    return [...acc, value];
  }, []);
  return (
    <Banner noIcon={props.noIcon} type="error">
      <ul>
        {errors.map(error => (
          <li key={`error-${error}`}>
            <span className="error-text">Error:</span> {error}
          </li>
        ))}
      </ul>
    </Banner>
  );
};
export default FormErrors;
